import { z } from "zod";

const featureFlagKeySchema = z
    .string()
    .max(100)
    .regex(/^[a-z0-9-]+$/);

export const featureFlagOverridePathParamsSchema = z.object({
    workspaceId: z.string().uuid(),
    flag: featureFlagKeySchema,
});

export const organizationFeatureFlagOverridePathParamsSchema = z.object({
    organizationId: z.string().uuid(),
    flag: featureFlagKeySchema,
});

export const setFeatureFlagOverrideBodySchema = z.object({
    isEnabled: z.boolean(),
});

export const featureFlagOverridesResponseSchema = z.object({
    overrides: z.record(z.boolean()),
    uiOnlyFlags: z.array(z.string()),
});

export type FeatureFlagOverridesResponse = z.infer<
    typeof featureFlagOverridesResponseSchema
>;

export const workspaceFeatureFlagOverridesResponseSchema =
    featureFlagOverridesResponseSchema.extend({
        organizationOverrides: z.record(z.boolean()),
    });

export type WorkspaceFeatureFlagOverridesResponse = z.infer<
    typeof workspaceFeatureFlagOverridesResponseSchema
>;
